export const API_HOST = 'https://api.charles.mirk.co'
export const CLIENT_ID = '1'
export const CLIENT_SECRET = 'FIYJMHXtnuARZV5AGHYCdgleOSLBnuEuNdLPPzTn'
export const WS_HOST = 'https://api.charles.mirk.co'
export const SENTRY_DSN = 'https://a5cf063529b84687bbe344d7a41140a9@sentry.io/1385969'
export const VAPID_PUBLIC_KEY = 'BOBTEdetNshLj/Yt1j+0/PmI1CzwLPkIUfga8dWNy+HKmWes78aAXOsGoPydb0xzE5RjEJ6js5AMwi0mayUBUeg='
export const COOKIE_DOMAIN = 'charles.mirk.co'
export const COOKIE_SECURE = true
